export default `float de(vec3 p){
    float diameter = 0.2;
    float height = 0.1;
    return max( length8(p.xz) - diameter, abs(p.y) - height );
  }`